export default __webpack_public_path__ + "static/media/New Bishops Consecration 1947.105efc3f.jpg";